import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav, Accordion } from "react-bootstrap";
//import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { handleActiveLink, handleLeft, setLocalTimezone } from '../../Actions/AllAction';
import { Tooltip } from 'react-tooltip';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { setToken, setUserCredentials, logOutApp, userrole } from '../../GlobalModules/Login/Actions/LoginAction';

import Utility from '../Utility';
import UtilityGlobal from '../../GlobalModules/Utility/Utility'
import EventEmitter from '../EventEmitter';

import { get } from '../Http';
import Config from '../Config';
import moment from 'moment-timezone';
import '@mt/vite_react_shadcn_ts/dist/style.css';


class Left extends Component {
    constructor(props) {
        super(props);
        this.handleBar = this.handleBar.bind(this);
        this.state = {
            toggleType: "",
            activeClass: "",
            accName: "",
            subMenuIcon: "",
            chatcount: 0,
            newMessageReceived: [],
        }
    }

    chatHistoryList = (data, version) => {
        return get(`${Config.extendedUrl}${version}/chat_history/list`, data).then((response) => {
            return response.data
        })
    };

    toggle = (params, linkType) => {
        if (linkType === "") {

            this.setState({
                collapsed2: true,
                accName: ""
            }, () => {
                this.props.handleActiveLink(this.state.activeClass, this.state.accName)

            });
        }
        localStorage.setItem("selectedTabName", "");
        this.setState({
            activeClass: params
        }, () => {
            this.props.handleActiveLink(this.state.activeClass, this.state.accName)
        });
    }

    handleBar = () => {
        this.props.handleLeft(!this.props.leftbar)
    }
    validationPermission = (eventKey) => {
        const { t, roleWisePermission } = this.props;
        let valid = false;
        if (roleWisePermission && roleWisePermission.hasOwnProperty(eventKey) && roleWisePermission[eventKey].read_write_permission != "") {
            valid = true;
        }
        return valid
    }

    componentDidMount() {
        this.addSocketConnection();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    addSocketConnection = () => {
        const { userCredentials, setLocalTimezone } = this.props;
        setLocalTimezone(moment.tz.guess())
        Utility.newSocketConnection(userCredentials.id, userCredentials.user_details.org_id)
        this.listnerForNewMessage();
        this.unreadMsgApi();
    }

    unreadMsgApi = () => {
        // console.log("lefttttttttttttttttt")
        const { userCredentials } = this.props;
        let filters = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["wa_status"] = null;
        globalQueryParamshash["message_type"] = "from";

        filters['filters'] = JSON.stringify(globalQueryParamshash);
        this.chatHistoryList(filters, userCredentials.user_details.version).then((response) => {
            if (response.success) {
                this.setState({
                    chatcount: response.total
                })
            } else {
                //Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
        }).catch((error) => {
            console.log('----------error-------', error);
        });
    }

    throttle = (callbackFn, limit) => {
        let wait = false;
        return function (...args) {
            if (!wait) {
                callbackFn.apply(this, args);
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, limit);
            }
        }
    }

    listnerForNewMessage = () => {
        const { userCredentials } = this.props;
        EventEmitter.addListener("receivedMessage", (message) => {
            // console.log("message[0]=====", message[0])
            if (userCredentials.user_details.org_id == message[0].org_id && message[0].message_type == "from") {
                this.unreadMsgApi();
            }
        })
        EventEmitter.addListener("message_seen", (message) => {
            this.unreadMsgApi();
        })
    }

    heardRefresh = () => {
        const reloadCount = parseInt(sessionStorage.getItem('reloadCount')) || 0;

        // If reload count is less than 1, force a hard refresh
        if (reloadCount < 2) {
            sessionStorage.setItem('reloadCount', reloadCount + 1);
            window.location.reload(true); // Hard refresh (from server)
        } else {
            sessionStorage.removeItem('reloadCount'); // Reset reload count after first reload
        }
    }

    // for control pannel added
    getScreenName = (screen_name) => {
        const { tabGridLabel } = this.props;
        const screenNames = tabGridLabel != undefined && tabGridLabel.map(item => item.screen_name);
        const lowerCaseScreenNames = screenNames.map(name => name.toLowerCase());
        if (lowerCaseScreenNames.includes(screen_name)) {
            let value = lowerCaseScreenNames.find(name => name == screen_name);
            return value;
        }
    }
    // end
    generalSettingPermissionWiseFn = (fieldName, uniqIdentifier = "refresh_view", screenName = "Left Panel") => {
        if (this.props.tabGridLabel && this.props.tabGridLabel.length > 0) {
            const gridItem = this.props.tabGridLabel.find(item =>
                item.screen_name === screenName &&
                item.uniq_identifier === uniqIdentifier
            );

            if (gridItem && gridItem.setting_data) {
                const fieldData = gridItem.setting_data.find(item => item.field_name === fieldName);
                return fieldData;
            }
        }
        return {};
    };

    leftUi = () => {
        const { t, roleWisePermission, userCredentials, tabGridLabel } = this.props; // for control pannel added
        const { activeClass, accName } = this.props.activeLink;
        let version = userCredentials.user_details.version;
        let orgnizationarry = ["worker", "addWorker"];

        let orgArry = [];
        let orgPermission = orgnizationarry.filter((item) => {
            let key = roleWisePermission && roleWisePermission.hasOwnProperty(item) ? roleWisePermission[item].eventKey : ""
            if (item == key) {
                orgArry.push(key)
            }
        })
        let arry = []
        //if (orgArry.length > 0) {
        //role permisson added
        let homePermission = false;
        let notificationHistoryPermission = false;
        let templateAndSettingsPermission = false;
        let contactPermission = false;
        let accountInfoPermission = false; // added for account module
        if (userCredentials.user_details?.user_type == "user" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "support_user") {
            if (Object.keys(UtilityGlobal.getRoleObjectByEventKey('home')).length > 0) {
                homePermission = true;
            }
            if (Object.keys(UtilityGlobal.getRoleObjectByEventKey('notificationHistory')).length > 0) {
                notificationHistoryPermission = true;
            }
            if (Object.keys(UtilityGlobal.getRoleObjectByEventKey('template&settings')).length > 0) {
                templateAndSettingsPermission = true;
            }
            if (Object.keys(UtilityGlobal.getRoleObjectByEventKey('contactsManagement')).length > 0) {
                contactPermission = true;
            }
            // added for account module
            if (Object.keys(UtilityGlobal.getRoleObjectByEventKey('accountInfo')).length > 0) {
                accountInfoPermission = true;
            }
            // end
        }
        // end role permisson added
        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type == 'app_admin' || userCredentials.user_details.user_type == 'admin' || (userCredentials.user_details.user_type == 'user' && homePermission) || (userCredentials.user_details.user_type == 'staff' && homePermission) ?
                arry.push(
                    <>
                        {/* <button onClick={() => this.heardRefresh()}>Refresh</button> */}
                        {this.generalSettingPermissionWiseFn('refresh_view').hasOwnProperty('current_status') && this.generalSettingPermissionWiseFn('refresh_view').current_status && Number(this.generalSettingPermissionWiseFn('refresh_view').current_status) == 1 ? <div className="hard_fresh_sec">
                            <button className="hard_fresh_button" onClick={() => { this.heardRefresh() }} data-tooltip-id="main-tooltip" data-tooltip-content="Refresh View"><i className="fa fa-refresh"></i>
                            </button>
                        </div> : null}

                        <Nav.Item className={activeClass === 'home_module' ? "ActiveClass" : "default"} id="home_module_id" onClick={this.toggle.bind(this, 'home_module', '')} key={0}>
                            <Link to={`/${localStorage.getItem('i18nextLng')}/home`} className="nav-link">
                                <div className="imgcircle" data-tooltip-id="main-tooltip" data-tooltip-content="Home"><img src={require('../Public/images/home.png')} className="sidebaricon" /></div>
                            </Link>
                        </Nav.Item>
                    </>
                )
                : null
        }
        //}

        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type == 'admin' || (userCredentials.user_details.user_type == 'user' && notificationHistoryPermission) || (userCredentials.user_details.user_type == 'staff' && notificationHistoryPermission) ?
                arry.push(
                    // for control pannel added
                    <Nav.Item className={activeClass === 'chat_module' ? "ActiveClass" : "default"} style={{ display: "flex" }} id="chat_module_id" onClick={this.toggle.bind(this, 'chat_module', '')} key={1}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/chat`} className="nav-link">
                            <div className="imgcircle" data-tooltip-id="main-tooltip" data-tooltip-content="Notification"><img src={require('../Public/images/chat_bubble.png')} className="sidebaricon" /></div>
                            {/* <div className="imgcircle" data-tip={tabGridLabel != undefined && this.getScreenName("notification") == "notification" ? this.getScreenName("notification") : "Notification History"}><img src={require('../Public/images/chat_bubble.png')} className="sidebaricon" /></div> */}
                        </Link>
                        {this.state.chatcount > 0 && version != "v2" ?
                            <span className='message_indication'></span>
                            :
                            null
                        }
                    </Nav.Item>
                )
                : null
        }

        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.version != "v1" && userCredentials.user_details.user_type == 'admin' || (userCredentials.user_details.user_type == 'user' && templateAndSettingsPermission) || (userCredentials.user_details.user_type == 'staff' && templateAndSettingsPermission) ?
                arry.push(
                    // for control pannel added
                    <Nav.Item className={activeClass === 'template_module' ? "ActiveClass" : "default"} id="chat_module_id" onClick={this.toggle.bind(this, 'template_module', '')} key={2}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/template`} className="nav-link">
                            <div className="imgcircle" data-tooltip-id="main-tooltip" data-tooltip-content="Template & Settings"><img src={require('../Public/images/setting.png')} className="sidebaricon" /></div>
                            {/* <div className="imgcircle" data-tip={tabGridLabel != undefined && this.getScreenName("template & settings") == "template & settings" ? this.getScreenName("template & settings") : "Template & Settings"}><img src={require('../Public/images/setting.png')} className="sidebaricon" /></div> */}
                        </Link>
                    </Nav.Item>
                ) : null
        }

        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type == 'app_admin' && userCredentials.user_details.version != "v1" ?
                arry.push(
                    <Nav.Item className={activeClass === 'template_module' ? "ActiveClass" : "default"} id="chat_module_id" onClick={this.toggle.bind(this, 'template_module', '')} key={2}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/template`} className="nav-link">
                            <div className="imgcircle" data-tooltip-id="main-tooltip" data-tooltip-content="Settings"><img src={require('../Public/images/setting.png')} className="sidebaricon" /></div>
                        </Link>
                    </Nav.Item>
                ) : null
        }

        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.version != "v1" && userCredentials.user_details.user_type == 'admin' || (userCredentials.user_details.user_type == 'user' && contactPermission) || (userCredentials.user_details.user_type == 'staff' && contactPermission) ?
                arry.push(
                    // for control pannel added
                    <Nav.Item className={activeClass === 'ContactManagement_module' ? "ActiveClass" : "default"} id="chat_module_id" onClick={this.toggle.bind(this, 'ContactManagement_module', '')} key={3}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/contact_management`} className="nav-link">
                            <div className="imgcircle" data-tooltip-id="main-tooltip" data-tooltip-content="Contact"><img src={require('../Public/images/contact.png')} className="sidebaricon" /></div>
                            {/* <div className="imgcircle" data-tip={tabGridLabel != undefined && this.getScreenName("contact management") == "contact management" ? this.getScreenName("contact management") : "Contact Management"}><img src={require('../Public/images/contact.png')} className="sidebaricon" /></div> */}
                        </Link>
                    </Nav.Item>
                ) : null
        }
        // added for account module
        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.version != "v1" && userCredentials.user_details.user_type != 'app_admin' ?
                arry.push(
                    // for control pannel added
                    <Nav.Item className={activeClass === 'Account_module' ? "ActiveClass" : "default"} id="chat_module_id" onClick={this.toggle.bind(this, 'Account_module', '')} key={4}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/account`} className="nav-link">
                            <div className="imgcircle" data-tooltip-id="main-tooltip" data-tooltip-content="Account"><img src={require('../Public/images/accounts.png')} className="sidebaricon" /></div>
                        </Link>
                    </Nav.Item>
                ) : null
        }
        // end
        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type == 'app_admin' && Config.includedVersion.includes(userCredentials.user_details.version) ?
                arry.push(
                    <Nav.Item className={activeClass === 'notification_module' ? "ActiveClass" : "default"} id="chat_module_id" onClick={this.toggle.bind(this, 'notification_module', '')} key={3}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/notification`} className="nav-link">
                            <div className="imgcircle notification_icon" data-tooltip-id="main-tooltip" data-tooltip-content="Notification"><i className="fa fa-bell-o" aria-hidden="true"></i></div>
                        </Link>
                    </Nav.Item>
                )
                : null
        }
        {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.version != "v1" && userCredentials.user_details.user_type != 'app_admin' &&
                (() => {
                    // CRM Pipeline
                    const crmPipelinePermission = this.generalSettingPermissionWiseFn('crm_pipeline');
                    const hasCrmPipelineAccess = crmPipelinePermission?.current_status && Number(crmPipelinePermission.current_status) === 1;
                    const crmDashboardPermission = this.generalSettingPermissionWiseFn('crm_dashboard');
                    const hasCrmDashboardAccess = crmDashboardPermission?.current_status && Number(crmDashboardPermission.current_status) === 1;
                    const crmProspectPermission = this.generalSettingPermissionWiseFn('crm_prospects');
                    const hasCrmProspectAccess = crmProspectPermission?.current_status && Number(crmProspectPermission.current_status) === 1;

                    if (hasCrmPipelineAccess) {
                        arry.push(
                            <Nav.Item className={activeClass === 'crm_pipeline_module' ? "ActiveClass" : "default"} id="crm_pipeline_id" onClick={this.toggle.bind(this, 'crm_pipeline_module', '')} key={5}>
                                <Link to={`/${localStorage.getItem('i18nextLng')}/crm-pipeline`} className="nav-link">
                                    <div className="imgcircle notification_icon" data-tooltip-id="main-tooltip" data-tooltip-content={crmPipelinePermission?.modified_field_caption || 'CRM Pipeline'}><i className="fa fa-filter" aria-hidden="true"></i></div>
                                </Link>
                            </Nav.Item>
                        );
                    }

                    // CRM Dashboard
                    if (hasCrmDashboardAccess) {
                        arry.push(
                            <Nav.Item className={activeClass === 'crm_dashboard_module' ? "ActiveClass" : "default"} id="crm_dashboard_id" onClick={this.toggle.bind(this, 'crm_dashboard_module', '')} key={6}>
                                <Link to={`/${localStorage.getItem('i18nextLng')}/crm-dashboard`} className="nav-link">
                                    <div className="imgcircle notification_icon" data-tooltip-id="main-tooltip" data-tooltip-content={crmDashboardPermission?.modified_field_caption || "CRM Dashboard"}><i className="fa fa-tachometer" aria-hidden="true"></i></div>
                                </Link>
                            </Nav.Item>)
                    }

                    // Prospects
                    if (hasCrmProspectAccess) {
                        arry.push(
                            <Nav.Item className={activeClass === 'prospects_module' ? "ActiveClass" : "default"} id="prospects_id" onClick={this.toggle.bind(this, 'prospects_module', '')} key={7}>
                                <Link to={`/${localStorage.getItem('i18nextLng')}/prospects`} className="nav-link">
                                    <div className="imgcircle notification_icon" data-tooltip-id="main-tooltip" data-tooltip-content={crmProspectPermission?.modified_field_caption || "Prospects"}><i className="fa fa-users" aria-hidden="true"></i></div>
                                </Link>
                            </Nav.Item>)
                    }
                    // CRM Scoring Admin
                    // arry.push(
                    //     <Nav.Item className={activeClass === 'crm_scoring_module' ? "ActiveClass" : "default"} id="crm_scoring_id" onClick={this.toggle.bind(this, 'crm_scoring_module', '')} key={7}>
                    //         <Link to={`/${localStorage.getItem('i18nextLng')}/crm-scoring-admin`} className="nav-link">
                    //             <div className="imgcircle notification_icon" data-tooltip-id="main-tooltip" data-tooltip-content="CRM Scoring Admin"><i className="fa fa-cogs" aria-hidden="true"></i></div>
                    //         </Link>
                    //     </Nav.Item>)
                    return null;
                })()
        }
        {/*
			userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type != 'app_admin' && userCredentials.user_details.version != "v2"?
				arry.push(
					<Nav.Item className={activeClass === 'integration_module' ? "ActiveClass" : "default"} id="integration_module_id" onClick={this.toggle.bind(this, 'integration_module', '')} key={5}>
						<Link to={`/${localStorage.getItem('i18nextLng')}/integration`} className="nav-link">
							<div className="imgcircle" data-tip="Integration"><img src={require('../Public/images/integration.png')} className="sidebaricon" /></div>
						</Link>
					</Nav.Item>
				)
				: null
		*/}
        /* {
            userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type == 'app_admin' ?
                arry.push(
                    <Nav.Item className={activeClass === 'appCreate_module' ? "ActiveClass" : "default"} id="appCreate_module_id" onClick={this.toggle.bind(this, 'appCreate_module', '')} key={6}>
                        <Link to={`/${localStorage.getItem('i18nextLng')}/app-create`} className="nav-link">
                            <div className="imgcircle" data-tip="Create App"><img src={require('../Public/images/app.png')} className="sidebaricon" /></div>
                        </Link>
                    </Nav.Item>
                )
                : null
        } */

        return arry;
    }


    render() {
        const { activeClass, accName } = this.props.activeLink;
        const { userCredentials } = this.props;

        let org_profile_image = "";
        let marketed_by_logo = "";
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('org_logo') && userCredentials.user_details.org_logo && userCredentials.user_details.org_logo.hasOwnProperty('file_obj') && userCredentials.user_details.org_logo.file_obj) {
            org_profile_image = userCredentials.user_details.org_logo.file_obj
        }
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('marketed_by_logo') && userCredentials.user_details.marketed_by_logo && userCredentials.user_details.marketed_by_logo.hasOwnProperty('file_obj') && userCredentials.user_details.marketed_by_logo.file_obj) {
            marketed_by_logo = userCredentials.user_details.marketed_by_logo.file_obj
        }


        return (
            <aside id="left_bar_id" className={this.props.leftbar ? 'left_bar_customize left-bar open hide-sm' : 'left_bar_customize left-bar closed hide-sm'}>
                {org_profile_image != "" &&
                    <div className="webtitlelogo">
                        <img src={org_profile_image} className="sidebarimg" data-tooltip-id="main-tooltip" data-tooltip-content={userCredentials.user_details.org_name} />
                        {/* <p className="chatitle">Mettle</p>
					<p className="peotitle">Tech</p> */}
                    </div>}
                <Nav className="flex-column pt-2 side-nav">

                    {this.leftUi()}
                    <Tooltip id="main-tooltip" place="right" />
                </Nav>

                {/* <div className="bottomlogo poweredBy"> */}
                {/* <div className={marketed_by_logo == "" ? "bottomlogo poweredBy bottomPoweredBy" : "bottomlogo poweredBy"}>
					<a href="https://mettletech.co/" target='_blank'>
						<img src={require('../Public/images/mettletech-logo4.png')} className="sidebarimg" data-tip="Mettle Tech" />
						<p>Powered By</p>
					</a>
				</div> */}
                {/* <div className="bottomlogo">
				<a href="#" target='_blank'>
					<img src={require('../Public/images/mettletech-logo4.png')} className="sidebarimg" data-tip="Marketed By" />
					<p>Marketed By</p>
					</a>
				</div> */}
                {/* {marketed_by_logo != "" &&
					<div className="bottomlogo marketedBy">
						<a href={userCredentials.user_details.marketed_by_url} target='_blank'>
							<div className='innmarketedBy'>
								<img src={marketed_by_logo} className="sidebarimg" data-tip={userCredentials.user_details.marketed_by_name} />
							</div>
							<p>Marketed By</p>
						</a>
					</div>

				} */}
            </aside>

        )

    }
}


function mapStateToProps(globalState) {
    return {
        leftbar: globalState.mainReducerData.leftbar,
        activeLink: globalState.mainReducerData.activeLink,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        userCredentials: globalState.LoginReducer.userCredentials,
        loginDetails: globalState.LoginReducer,
        tabGridLabel: globalState.LoginReducer.tabGridLabel, // for control pannel added

    };
}

export default connect(mapStateToProps, { handleActiveLink, handleLeft, setToken, setLocalTimezone })(withTranslation()(Left));